module.exports = __webpack_public_path__ + "local-ads.7ac508c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/AdminRegistration/local-ads.png
// module id = 3128
// module chunks = 0